import http from './api'

const route = 'recover/'

export default {
    verificaEmpresa: (tokencontrato) => {
        return http.post(route + 'verifica_empresa', {
            tokencontrato: tokencontrato,
        })
    },

    resetPassword: (username, url, tokencontrato) => {
        return http.post(route + 'reset_password', {
            username: username,
            url: url,
            tokencontrato: tokencontrato,
        })
    },

    newPassword: (user, tokencontrato) => {
        return http.post(route + 'new_password', {
            user: user,
            tokencontrato: tokencontrato,
        })
    },

    verificaCodigoAtivacao: (codigo) => {
        return http.post(route + 'verifica_codigo', {
            codigo: codigo,
        })
    },
}
